export const sliceImg = [
    {
        id: 1,
        linkImg:'https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg'
    },
    {
        id: 2,
        linkImg:'https://m.media-amazon.com/images/I/61LM7RVxQPL._SX3000_.jpg'
    },
    {
        id: 3,
        linkImg:'https://m.media-amazon.com/images/I/61cSozkWFcL._SX3000_.jpg'
    },
    {
        id: 4,
        linkImg:'https://m.media-amazon.com/images/I/612fp2VjB0L._SX3000_.jpg'
    }
]

export const footer_information = [
    {
        title: "Get to Know Us",
        content: ["Careers", "Amazon and Our Planet","Investor Relations","Press Releases","Amazon Science"]
    },
    {
        title: "Make Money with Us",
        content: ["Sell on Amazon", "Amazon Associates","Sell on Amazon Handmade","Advertise Your Products","Independently Publish with Us","Host an Amazon Hub"]
    },
    {
        title: "Amazon Payment Products",
        content: ["Amazon.ca Rewards Mastercard", "Shop with Points","Reload Your Balance","Amazon Currency Converter","Gift Cards","Amazon Cash"]
    },
    {
        title: "Let Us Help You",
        content: ["COVID-19 and Amazon", "Shipping Rates & Policies","Amazon Prime","Returns Are Easy","Manage your Content and Devices","Customer Service"]
    }
]

export const productInfo = [
    {
        id: 1,
        content: [
            {
                id:"12321341",
                title:"The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback",
                price:11.96,
                rating:5,
                image:"https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._SX325_BO1,204,203,200_.jpg"
            },
            {
                id:"49538094",
                title:"Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl",
                price:239.0,
                rating:4,
                image:"https://images-na.ssl-images-amazon.com/images/I/81O%2BGNdkzKL._AC_SX450_.jpg"
            },
        ]
    },
    {
        id: 2,
        content: [
            {
                id:"4903850",
                title:"Mgaolo Fitness Tracker with Blood Oxygen SpO2 Heart Rate Sleep Monitor,Waterproof Health Activity Tracker for Android and iOS,11 Sport Modes Watch with Pedometer Calorie Counter for Men Women",
                price:199.99,
                rating:3,
                image:"https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"
            },
            {
                id:"23445930",
                title:"Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric",
                price:98.99,
                rating:5,
                image:"https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
            },
            {
                id:"3254354345",
                title:"New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)",
                price:598.99,
                rating:4,
                image:"https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
            }
        ]
    },
    {
        id: 3,
        content: [
            {
                id:"90829332",
                title:"Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440",
                price:1094.98,
                rating:4,
                image:"https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"
            }
        ]
    }
]